import { render, staticRenderFns } from "./CustomerEdit.vue?vue&type=template&id=6d6a303a&"
import script from "./CustomerEdit.vue?vue&type=script&lang=ts&"
export * from "./CustomerEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports